import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {IconComponent, IconName} from '@adnova/jf-ng-components';


export interface SnackbarData {
  message: string;
  icon?: IconName;
  iconSize?: number;
  iconStrokeWidth?: number;
}

@Component({
  selector: 'app-custom-snackbar',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './custom-snackbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./custom-snackbar.component.scss']
})
export class CustomSnackbarComponent {
  protected data = inject<SnackbarData>(MAT_SNACK_BAR_DATA);
}
